jQuery(document).ready(function($){
  	$(".search-field").click(function(e){
		e.preventDefault();
    
		$(".header-search-mobile").slideToggle();
		$(".search-field a").toggleClass("fa-search");
      $(".search-field a").toggleClass("fa-times");
      
      $(".search-field").toggleClass("select");
			var target = $(e.target);
		if(target.is(".search-field.select")) {
         
			
        
        $(".search-field").removeClass("select");
			$(".header-search-mobile").hide();
		}
    });
  
$( "#nav-toggle" ).on( "click", function(e) {	
e.preventDefault();
 e.stopPropagation();
  $("body").toggleClass("ln");
 $(this).toggleClass("active");

});

$(".close").click(function(e){
	 if ($(e.target).hasClass('tab-hide')) {
	 return false;
	 }
  $("body").removeClass("ln");	
});

$(".wrapper-shopify").click(function(){
 $("body").removeClass("ln");
   $( "#nav-toggle" ).removeClass( "active" );
 });

	$('.tab-hide').click(function(e){
	$(this).find(".toggleDiv").slideToggle();
	$(this).toggleClass("select");
	});

$('.moreList').owlCarousel({
    loop:true,
    margin:10,
    dots:false,
    navText: [ , ],
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        540:{
            items:2,
            nav:true
        },
        768:{
            items:4,
            nav:false
        }
     
    }
});

$('.fbclick').click(function(event) {
var width  = 575,
    height = 400,
    left   = ($(window).width()  - width)  / 2,
    top    = ($(window).height() - height) / 2,
    url    = this.href,
    opts   = 'status=1' +
             ',width='  + width  +
             ',height=' + height +
             ',top='    + top    +
             ',left='   + left;

window.open(url, 'twitter', opts);

return false;
});

$('#load_blog').on('click',function(e) {
e.preventDefault();
$('#ajax-loader').show();
	 var pagenum = $("#pagenum").text();
	 var pathname = window.location.pathname;
		  $.get('/blogs/blog?page='+pagenum, function(response){
			if(response){	
				 var $result = $(response).find('.blog-list .all_articles').html();
				 if ($result.trim()) {
						 $('.all_articles').append($result);
						 $('#ajax-loader').hide(); 
					}else{
						$('#load_blog').replaceWith('<p style="margin-bottom:60px;">No More Articles found.</p>');
						$('#ajax-loader').hide(); 
					}
			}
		  });
      $('#pagenum').html(function(j, val) {return val*1+1 });		  	   
});	 

  var winWidth = $(window).width();
    var conteainerWidth = $(".container").width();
    var margin = (winWidth - conteainerWidth)/2;
    $( "#nav-toggle" ).css("left", margin);
    $(window).resize(function(){
            var winWidth = $(window).width();
    var conteainerWidth = $(".container").width();
    var margin = (winWidth - conteainerWidth)/2;
    $( "#nav-toggle" ).css("left", margin);
});

 var byRow = $('body').hasClass('innerPage');
$('.grid-link__image--product').matchHeight({
	byRow: byRow
}); 

var $grid = $('.collection-gallery').masonry({
        itemSelector: '.collection-gallery-item',
        isFitWidth: true,
        columnWidth: 1
    });

    $grid.imagesLoaded().progress(function() {
        $grid.masonry('layout');
    });

$(window).resize(function(){ 
 $grid.imagesLoaded().progress(function() {
        $grid.masonry('layout');
    });
});

$('.popup-youtube, .popup-vimeo').magnificPopup({
          disableOn: 700,
          type: 'iframe',
          mainClass: 'mfp-fade',
          closeOnBgClick: true,
          closeBtnInside: false,
          closeOnContentClick: true,
          tClose: '',
          removalDelay: 500,
		  callbacks: {
            open: function(){
              $('html').css('overflow-y','hidden');
            },
            close: function(){
              $('html').css('overflow-y','');
            }
          },
	iframe: {
        patterns: {
			youtube: {
                 index: 'youtube.com/',
                 id: '/', 
	             src: '//www.youtube.com/embed/%id%?autoplay=1'
            },
            vimeo: {
                index: 'vimeo.com/', 
                id: '/',
                src: '//player.vimeo.com/video/%id%?autoplay=1'
            }
        }
    }
});

$('.gallery').each(function() { 
    $(this).magnificPopup({
        delegate: 'a', 
        type: 'image',
		mainClass: 'mfp-fade',
          closeOnBgClick: true,
          closeBtnInside: false,
          closeOnContentClick: true,
           tClose: '',
          removalDelay: 500,
          callbacks: {
            open: function(){
              $('html').css('overflow-y','hidden');
            },
            close: function(){
              $('html').css('overflow-y','');
            }
          },
        gallery: {
           enabled: true,
            navigateByImgClick: false,
            arrowMarkup: '<button type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
             tPrev: 'Previous',
             tNext: 'Next'
        }
    });
});

$(".clickBox").click(function(e){e.preventDefault(); e.stopPropagation();
 $(".catListing").slideToggle();
});

$("a.hide-next, a.hide-prev").click(function(e){
   e.preventDefault();
});

$('span.sr-only').hide();
  
  
    var winsWidth = $(window).width();
    var conteainersWidth = ($(".container").width())+20;
    var margins = (winsWidth - conteainersWidth)/2;
    $( ".header-search-mobile" ).css({
      "left": margins,
      "width": conteainersWidth
    });
    $(window).resize(function(){
             var winsWidth = $(window).width();
    var conteainersWidth = ($(".container").width())+20;
    var margins = (winsWidth - conteainersWidth)/2;
     $( ".header-search-mobile" ).css({
      "left": margins,
      "width": conteainersWidth
    });
});
  


$('#mc-embedded-subscribe').click(function(e) {
var $_email = $('#mc-embedded-subscribe-form #MERGE0').val();	
            if($_email == ''){
				$('.errors').show();	
				$('.errors ul li').html('Please Enter Required fields.');
				return false;
            }else if(!isEmail($('#MERGE0').val())){
				$('.errors').show();
				$('.errors ul li').html('Please Enter a Valid Email Address.');
                return false;
			}else {
				$('.errors').hide();
				$('.errors ul li').html('');
				$('#mc-embedded-subscribe-form').attr('target', '_blank');
                $('#mc-embedded-subscribe-form').submit();
		    }
});

$("#register_user").click(function(e) {     
$('.errors').hide();	
var firstname = $("#FirstName").val();
var lastname = $("#LastName").val();
var email = $("#Email").val();
var password = $("#CreatePassword").val();
var confirmpassword = $("#ConfirmPassword").val();
        if( (firstname == '') || (lastname == '') || (email == '') || (password == '') || (confirmpassword == '')){
                $('.errors').show();	
				$('.errors ul li').html('Please Enter Required fields.');
				return false;
         }else if(!isEmail($('#Email').val())){
		        $('.errors').show();
				$('.errors ul li').html('Please Enter a Valid Email Address.');
                return false;
		 }else if(confirmpassword !== password){
		        $('.errors').show();
				$('.errors ul li').html('Confirm password does not match.');
                return false;
		 }else{
                $('.errors').hide();
				$('.errors ul li').html('');
				$('#create_customer').submit();
		 }
});

$("#login_sub").on("click", function(e) {	
$(".errors").hide();
var email = $("#CustomerEmail").val();
var password = $("#CustomerPassword").val();
      if((email == '') || (password == '')){
                $(".errors").show();	
				$(".errors ul li").html("Please Enter Required fields.");
				return false;
         }else if(!isEmail($("#CustomerEmail").val())){
		        $(".errors").show();
				$(".errors ul li").html("Please Enter a Valid Email Address.");
                return false;
		 }else{
                $(".errors").hide();
				$(".errors ul li").html('');
				$('#customer_login').submit();
		 }    
});

$('.errors1').hide();
$("#recover-email").on("click", function(e) {	
$(".errors1").hide();
var email = $("#RecoverEmail").val();
         if(email == ''){
                $(".errors1").show();	
				$(".errors1 ul li").html("Please Enter Email Address.");
				return false;
         }else if(!isEmail($("#RecoverEmail").val())){
		        $(".errors1").show();
				$(".errors1 ul li").html("Please Enter a Valid Email Address.");
                return false;
		 }else{
                $(".errors1").hide();
				$(".errors1 ul li").html('');
				$('#RecoverPasswordForm form').submit();
		 }    
});


$(".reset-password").click(function(e) {     
$('.errors').hide();	
var password = $("#ResetPassword").val();
var confirmpassword = $("#PasswordConfirmation").val();
        if((password == '') || (confirmpassword == '')){
                $('.errors').show();	
				$('.errors ul li').html('Please Enter Required fields.');
				return false;
         }else if(confirmpassword !== password){
		        $('.errors').show();
				$('.errors ul li').html('Confirm password does not match.');
                return false;
		 }else{
                $('.errors').hide();
				$('.errors ul li').html('');
				$('#reset_password_form form').submit();
		 }
});

$(".catListing li:eq(0)").before($(".catListing li:eq(2)"));
$(".catListing li:eq(2)").before($(".catListing li:eq(3)")); 


var image_url = $('.imgpick img').attr('src');
var image_alt_val = $('.imgpick img').attr('alt');
var image_title = $('.imgpick img+h1').html();
if(image_url){
  $('.hero-img img').attr('src',image_url);
  $('.imgpick img').attr('src','');  
  $('.imgpick img').css({"display": "none"});
}
if (image_alt_val == 'collection small image') {
$('header').parent('div').addClass('header-wrap');
}
if(image_title != ''){
	 $('.hero-img h1').html(image_title);
	 $('.imgpick img+h1').html('');
	 $('.imgpick img+h1').css({"display": "none"}); 
}else{
 $('.imgpick img+h1').css({"display": "none"}); 	
} 
   
if ( $('.rotator-hero-img').hasClass("rotator-hero-img") ) {
  $('header').parent('div').addClass('header-wrap');
} 

$('.collection-catpro').each(function(i,e){
	var coll_catId = $(this).attr('id');
	$('#'+coll_catId).each(function(i,e){
		var coll_item = $('#'+coll_catId+' .col-lg-4').length;
		 if(coll_item > 3){
			$('#'+coll_catId).removeClass('collection-catpro');
		}
	});
});

$('ul.main-nav > .top-nav').on('mouseenter', function(e){
    if($(this).find('.toggleDiv ul.sub-list').length > 0) {
      $(this).find('.toggleDiv').stop(true, true).delay(100).slideDown(500);    
	  $(this).delay(700).addClass('select'); 
    }
}).on('mouseleave', function(e){
    if($(this).find('.toggleDiv ul.sub-list').length > 0) {
      $(this).find('.toggleDiv').stop(true, true).delay(100).slideUp(500);  
	  $(this).delay(700).removeClass('select');
    }
});

});

jQuery(window).load(function() {  
var url_path = window.location.href;
var url_path_accessories = "https://www.peacetradelove.com/collections/accessories/";
var url_path_accessories1 = "https://www.peacetradelove.com/collections/accessories";  
var url_path_bags = "https://www.peacetradelove.com/collections/bags/";
var url_path_bags1 = "https://www.peacetradelove.com/collections/bags";
var url_path_home = "https://www.peacetradelove.com/collections/home/";
var url_path_home1 = "https://www.peacetradelove.com/collections/home";  
var url_path_jewelry = "https://www.peacetradelove.com/collections/jewelry/";
var url_path_jewelry1 = "https://www.peacetradelove.com/collections/jewelry";  
  
if((url_path == url_path_accessories) || (url_path == url_path_accessories1) ){
  window.location.href = "https://www.peacetradelove.com/collections/accessories/all";
}  
if((url_path == url_path_bags) || (url_path == url_path_bags1)){
  window.location.href = "https://www.peacetradelove.com/collections/bags/all";
}  
if((url_path == url_path_home) || (url_path == url_path_home1)){
  window.location.href = "https://www.peacetradelove.com/collections/home/all";
} 
if((url_path == url_path_jewelry) || (url_path == url_path_jewelry1)){
  window.location.href = "https://www.peacetradelove.com/collections/jewelry/all";
}   
});